export enum SectionStatus {
  complete,
  incomplete,
  todo,
  empty,
}
